import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VirkeskostnadBaseCommand } from "./VirkeskostnadBaseCommand";

export class DeleteVirkeskostnaderCommand extends VirkeskostnadBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DeleteVirkeskostnaderCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "virkeskostnader";

    constructor(guid: string, atgardGuid: string, kontraktGuid: string) {
        super(DeleteVirkeskostnaderCommand.$type, CommandType.Delete);
        this.guid = guid;
        this.virkeskopsatgardGuid = atgardGuid;
        this.virkeskopskontraktGuid = kontraktGuid;
    }
}
